import {DestroyRef, Directive, inject, OnDestroy} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {switchMap} from 'rxjs/operators';
import {RealtimeChannelService, UserContextService} from '@pages/home/pusher-listener/pusher-listener.service';
import {NotificationsUpdateService} from '@services/notifications/notifications-update.service';

export interface NewNotificationPayload {
  userId: string;
  tenantId: string;
  unreadCount: number;
}

export const NOTIFICATION_EVENT = 'new-notification-received';

@Directive({
  selector: '[octGlobalNotifications]'
})
export class GlobalNotificationsDirective implements OnDestroy {
  private readonly _notificationsUpdateService = inject(NotificationsUpdateService);
  private readonly _userContext = inject(UserContextService);
  private readonly _realtime = inject(RealtimeChannelService);
  private readonly _destroyRef = inject(DestroyRef);

  constructor() {
    this._listenToNotifications();
  }

  private _listenToNotifications() {
    this._userContext.userContext
      .pipe(
        switchMap(channel => this._realtime.listen<NewNotificationPayload>(channel, NOTIFICATION_EVENT)),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe(payload => this._notificationsUpdateService.shouldReloadNotifications(payload?.unreadCount ?? 0));
  }

  ngOnDestroy() {
    this._realtime.unsubscribe();
  }
}
